import * as React from "react";
import { Edit, SimpleForm, TextInput, NumberInput, List, Datagrid, TextField, NumberField, DateField, Create } from 'react-admin';

const ShootDayTypesTitle = props => {
    return <span>{props.record ? `${props.record.name}` : ''}</span>;
};

export const ShootDayTypesList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="code" />
            <TextField source="name" />
            <TextField source="work_day_length" label="Work Day Length" />
            <TextField source="meal_length" label="Meal Length" />
            <NumberField source="meal_trigger_hours" label="Meal Trigger (hrs)" />
            <DateField source="created_at" />
        </Datagrid>
    </List>
);

export const ShootDayTypesEdit = props => (
    <Edit {...props} title={<ShootDayTypesTitle />} undoable={false}>
        <SimpleForm redirect="list">
            <TextInput source="code" />
            <TextInput source="name" />
            <TextInput source="work_day_length" label="Work Day Length" />
            <TextInput source="meal_length" label="Meal Length" />
            <NumberInput source="meal_trigger_hours" label="Meal Trigger (hrs)" step={0.25} min={0} />
        </SimpleForm>
    </Edit>
);

export const ShootDayTypesCreate = props => (
    <Create {...props} title={<ShootDayTypesTitle />} undoable={false} redirect="list">
        <SimpleForm redirect="list">
            <TextInput source="code" />
            <TextInput source="name" />
            <TextInput source="work_day_length" label="Work Day Length" />
            <TextInput source="meal_length" label="Meal Length" />
            <NumberInput source="meal_trigger_hours" label="Meal Trigger (hrs)" step={0.25} min={0} defaultValue={6} />
        </SimpleForm>
    </Create>
);